<template>
    <div id="DomPoint" class="div__item" v-if="spaces.length">
      <div class="space-card" @click="spaceBlock(item, $event)" v-for="(item, index) in spaces" :key="index">
        <div class="space-image">
          <img v-if="item.coverUrl" class="space-avstar" :src="$hosts.static(item.coverUrl)" alt=""/>
          <img v-else class="space-avstar" :src="require('@/assets/img/spaceBg.png')" alt="" />
        </div>
        <div class="card-foot">
          <span :title="item.name" class="space-name text-no-wrap card-foot-txt">
            {{ item.name }}
          </span>
          <div class="owner-text">
            <span class="creator-name text-no-wrap card-foot-txt">所有者：{{ item.creatorName }}</span>
            <el-dropdown class="dropdown-container" v-if="item.isOwner" placement="bottom">
              <span class="el-dropdown-link">
                <i class="el-icon-more ft-theme"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="font-size: 14px;" @click.native="()=>$emit('edit-space', item.id)">编辑信息</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'GjwSpaceListCard',
  props: {
    spaces: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  created() {
  },
  methods: {
    // 进入空间
    spaceBlock(item, event) {
      if (event.target.closest('.dropdown-container')) {
      // 如果点击来源是 el-dropdown，不进入空间
        return
      }
      this.$api.space.getSpacesDetail(item.id)
        .then(() => {
          sessionStorage.setItem('spaceName', item.name)
          this.$router.push({
            name: 'ComponentList',
            params: { spaceId: item.id }
          })
        })
        .catch((error) => {
          console.error('获取空间详情时出错:', error)
          if (error.code === 'space.not.exists') {
            this.$message.error(`该空间不存在,请刷新界面！`)
          } else {
            this.$message.error('获取空间详情失败，请刷新后重试')
          }
        })
    },
    // 编辑空间列表
    editOK(res) {
      const spaces = this.spaceLists.filter((item) => item.id === res.id)
      if (spaces && spaces.length > 0) {
        spaces[0].name = res.name
        spaces[0].coverUrl = res.coverUrl
      }
    },
  },
}
</script>

<style lang="less" scoped>
.div__item {
    width: 1200px;
    margin: auto;
    margin-bottom: 50px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    .space-card {
      width: 227.2px;
      height: 180px;
      border: 1px solid #d2d9e3;
      border-radius: 2px;
      cursor: pointer;
      box-shadow: none;
      .space-avstar {
        width: 225.2px;
        height: 122px;
        object-fit: cover;
        border-bottom: 1px solid #d2d9e3;
      }

      .card-foot {
          position: relative;
          top: -3px;
          height: 55px;
          cursor: pointer;
      }

      .card-foot-txt {
          display: block;
          height: 20px;
          padding: 6px 0 0 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
      }

      .creator-name {
          font-size: 12px;
          color: @color-text-breadcrumb;
          flex: 1;
      }
      .space-name {
        font-weight: bold; 
        color: #495f70;
      }
    }
}

.el-icon-refresh-right {
  color: #009ee1;
  padding-left: 6px;
  cursor: pointer;
}

.space-card:hover {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
    .creator-name {
        color: #495f70 !important;
    }
}

.owner-text {
    display: flex;
}

.dropdown-container {
    padding: 0 10px 0 0;
    align-content: center;
}
.el-dropdown-menu__item {
  padding: 0 10px !important;
}
.el-icon-more{
  color: #495F70;
}
.el-dropdown-link {
  padding: 2px 3px;
}
.el-dropdown-link:hover {
  padding: 2px 3px;
  background: #D6F3FF;
  border-radius: 4px;
  .card-foot {
    background: #DAE0E8;
  }
}
</style>
